export const MigrationStatus = {
  UNMIGRATED: 'unmigrated',
  QUEUED: 'queued',
  MIGRATING: 'migrating',
  MIGRATED: 'migrated',
  ERROR: 'error',
} as const
export type MigrationStatus = typeof MigrationStatus[keyof typeof MigrationStatus]

export const MigrationCohort = {
  // Phase 1 → internal staff (adult dogs only)
  PHASE1_STAFF: 'phase1_staff',
  // Phase 2 → low engagement active customers (≥ 6 week customers)
  PHASE2_LE_CUSTOMERS: 'phase2_low_engagement_customers',

  // TODO: TBC other phases as long as we process
  // Phase 3 → Cancelled & Paused customers Weightings TBC
  // Phase 4 → remaining active customers (per delivery cadence) Weightings TBC
  // Phase 5 → new customers (BaB) Weightings TBC
  // Phase 6 → partnerships Weightings TBC
} as const
export type MigrationCohort = typeof MigrationCohort[keyof typeof MigrationCohort]


export const MigrationPath = {
  BULK: 'bulk',
  BAB_CHECKOUT: 'bab_checkout',
} as const
export type MigrationPath = typeof MigrationPath[keyof typeof MigrationPath]

export const DogGender = {
  MALE: 'male',
  FEMALE: 'female',
} as const
export type DogGender = typeof DogGender[keyof typeof DogGender]

export const DogBodyType = {
  UNDERWEIGHT: 'slim',
  NORMAL: 'perfect',
  OVERWEIGHT: 'chunky',
} as const
export type DogBodyType = typeof DogBodyType[keyof typeof DogBodyType]

export const DogActivityLevel = {
  LOW: 'chilled',
  MEDIUM: 'loves_to_play',
  HIGH: 'ball_of_energy',
} as const
export type DogActivityLevel = typeof DogActivityLevel[keyof typeof DogActivityLevel]

export const DogEatingHabits = {
  VERY_FUSSY: 'very_fussy',
  CHOOSY: 'choosy',
  EATS_ANYTHING: 'eats_anything',
} as const
export type DogEatingHabits = typeof DogEatingHabits[keyof typeof DogEatingHabits]

export const DogLifestage = {
  PUPPY: 'puppy',
  ADULT: 'adult',
} as const
export type DogLifestage = typeof DogLifestage[keyof typeof DogLifestage]
